import { render, staticRenderFns } from "./TariffComparisionProperties.vue?vue&type=template&id=d67e12de"
import script from "./TariffComparisionProperties.vue?vue&type=script&lang=js"
export * from "./TariffComparisionProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports